import { HostListener, Injectable, NgZone } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { AuthenticationService } from './authenticationService';
import { Observable, throwError, of, from } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { StringConstants } from '../_constants/stringConstants';
import { DialogService } from './dialog.service';
import { CommonService } from './common.service';
import { Config } from '../_store';
import { NavController } from '@ionic/angular';
import { OfflineService } from './offlineService';
import { HTTP } from '@ionic-native/http/ngx';
import { Platform } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { ObjectTransformService } from './object-transform.service';
import { DynamicDataTranslationService } from './dynamicDataTranslationService';
import { Router } from '@angular/router';
import { RouteNavigationService } from './routeNavigationService';
import { AppDialogsService } from './appDialogsService';
import { environment } from '../../environments/environment';

type HttpMethod = 'get' | 'post' | 'put' | 'patch' | 'head' | 'delete' | 'upload' | 'download';

@Injectable({
  providedIn: 'root'
})

export class CustomHttpInterceptor implements HttpInterceptor {

  constructor(
    private authenticationService: AuthenticationService,
    private dialogService: DialogService,
    private offlineService: OfflineService,
    private commonService: CommonService,
    private transformService: ObjectTransformService,
    private nativeHTTP: HTTP,
    private translate: TranslateService,
    platform: Platform,
    private dynamicDataTranslationService: DynamicDataTranslationService,
    private appDialogsService: AppDialogsService,
    private routerService: RouteNavigationService
  ) {
    platform.ready().then(() => {
      this.nativeHTTP.setDataSerializer("utf8");
      this.nativeHTTP.setServerTrustMode("pinned").then(() => {
      }).catch((err) => {
      });
    });
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const postProcessRes = (event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
        let res = event.body;
        // Language labels
        if (res.msgCode && res.msg) {
          res.defaultMsg = this.commonService.getStringWithTemplateValues(res.msg, res.data);
          res.msg = this.dynamicDataTranslationService.getTranslatedTextForLabel(`MESSAGES.${res.msgCode}`, res.defaultMsg, res.data);
        }
        const isDashboardURL = event.url.toLowerCase().indexOf((Config.dashboardServiceURL || '').toLowerCase()) !== -1;
        const urlEndPoint = event.url.substring(event.url.lastIndexOf('/'));
        const isErrorPassOnToServiceURL = StringConstants.PASS_ON_ENDPOINTS.indexOf(urlEndPoint) !== -1;
        //
        const UI = this.commonService.getCurrentPlatformType();
        const transformNWCalls = Config.transformNWCalls && (UI !== 2 ? Config.transformNWCallsDevice : true) && !isDashboardURL && (res && !res.isOffline);
        if (transformNWCalls && res && res.result) {
          try {
            res = this.transformService.transformService(res.result);
            if (res) {
              res = JSON.parse(res);
            }
          }
          catch (err) {
            console.error(err);
          }
        }
        if (res) {
          if (res.message && !res.msg) {
            res.msg = res.message;
          }
          if (!res.message && res.msg) {
            res.message = res.msg;
          }
        }
        const isServiceSessionTimeout = (res.msg || '').toLowerCase().indexOf('invalid session') === 0;
        if (res && (res.code === '401' || res.code == '403' || isServiceSessionTimeout)) {
          const logoutUrl = event.url && event.url.indexOf('/logout') !== -1;
          if (!logoutUrl) {
            this.authenticationService.logout();
          }
          throw new Error(res.body);
        }
        // this.errorDialogService.openDialog(event);
        if (res) {
          const serviceRes: any = res;
          const isSuccess = (serviceRes.status || serviceRes.success)
          const err = serviceRes.error || serviceRes.msg;
          if ((!isSuccess || serviceRes.status === 'error') && err) {
            if (StringConstants.PASS_ON_ERRORS.indexOf(err.toLowerCase()) === -1 && !isErrorPassOnToServiceURL) {
              throw new Error(serviceRes.error || res.msg);
            }
          }
        }
        const urlIsForView = event.url && (event.url.indexOf('/error') === -1 || event.url.indexOf('invoice_data') === -1)
        if (!res && !urlIsForView) {
          throw new Error(this.translate.instant('MESSAGES.SERVER_GENERAL_ERROR'));
        }
        if (!res && (event.url && event.url.indexOf('/error') !== -1)) {
          throw new Error(this.translate.instant('MESSAGES.DOC_NOT_FOUND'));
        }
        return new HttpResponse({ status: 200, body: (res as any) });
      }
      return event;
    }
    const errHandler = (error: HttpErrorResponse) => {
      const errorCode = error && error.status;
      const errorObj = error.error || {};
      if (!navigator.onLine) {
        this.dialogService.showServerError('nointernet');
      } else {
        let data = {
          message: errorObj.reason || errorObj.msg || error.message || errorObj,
          status: error.status,
          header: 'Error'
        };
        if (errorCode === 404 || data.message.indexOf('document not found') !== -1) {
          this.dialogService.showMessageDialog(this.translate.instant('MESSAGES.DOC_NOT_FOUND')).then(() => {
          });
        } else if (data.message.indexOf('Oops! There seems') !== -1 || data.message.indexOf('Unknown') !== -1) {
          this.dialogService.showServerError('servererror');
        } else if (errorCode == 400){
          this.dialogService.showMessageDialog(this.translate.instant('MESSAGES.NO_DATA_AVAILABLE_FOR_SELECTED_CRITERIA_REVISE_YOUR_SEARCH')).then(() => {
          });
        } else{
        //   this.dialogService.showMessageDialog(data.message).then(() => {
        //     if(error.status === 403){
        //      this.routerService.navigateToLoginPage();
        //     }
        //  });
          //}
          let options = {
            isCoalIndia : false,
          }
          if(data.message === 'Invalid username or password'){
            data.message = `Invalid username or password, if you are a Coal India Customer.`
            options.isCoalIndia = true;
          }else if(data.message === 'Sorry, your mobile number is not registered with us. Please contact your Seller or Relationship Manager.'){
            data.message = `Sorry, your mobile number is not registered with us. Please contact your Seller or Relationship Manager. if you are a Coal India Customer.`
            options.isCoalIndia = true;
          }
        }
      }
      return throwError(error);
    }
    const currentUser = this.authenticationService.currentUserValue || {};
    const url = request.url;
    const reqBody = request.body;
    const action = reqBody && reqBody.action;
    // Variable which checks if user's session timedout and still request is coming to interface
    // Possible on states where multiple calls are made, e.g. payment page
    const isLogoutURL = url.indexOf('/logout') !== -1;
    const sessionTimedout = this.authenticationService.getIsUserSessionTimedout();
    if (sessionTimedout && !isLogoutURL) {
      return;
    }
    if (!isLogoutURL) {
      const isSessionTimedout = this.authenticationService.checkLastActivityTime();
      if (isSessionTimedout) {
        throw new Error('SESSIONTIMEOUT');
      }
    }
    this.authenticationService.setLastActivityTime();
    //UI is common param to be sent in each request, 1 for android, 2 for web and 3 for ios
    const UI = (this.commonService.getCurrentPlatformType()).toString();
    const isPOST = request.method === 'POST';
    const deviceInfo = (this.commonService.getDeviceInfo() || '').toString();
    const isEIPP = request.url.indexOf('/eipp/') !== -1;
    const isPayEXDCAPI = request.url.indexOf('/PayEXDCAPI/') !== -1;
    if (Config.isOffline) {
      if(isEIPP){

        const urlCopy = url.split(`${environment.base}/`);
        return from(
          this.offlineService.getDummyResponse(urlCopy[1], request.body).then((response) => 
            new HttpResponse({ status: 200, body: response as any })
          )
        );
      } else if (isPayEXDCAPI){
        console.log("yes node");
        console.log(url);
        const urlCopy = url.split(`${environment.nodeAPIUrl}`)
        console.log(environment.nodeAPIUrl);
        
        console.log(urlCopy);
        
        return of(new HttpResponse({ status: 200, body: ((this.offlineService.getDummyResponseNodeURL(url,request.body)) as any) }));

      }
    }
    if (isPOST) {
      reqBody.UI = UI;
      const transformedReq: any = {
        headers: Config.addDeviceInfoToHeaders ? request.headers.set('DeviceInfo', deviceInfo) : request.headers,
        url: url,
        body: Object.assign({}, reqBody, { skipInterceptor: undefined }, { session: currentUser.session })
      }
      const transformNWCalls = Config.transformNWCalls && (UI !== '2' ? Config.transformNWCallsDevice : true);
      // if (transformNWCalls) {
      //   transformedReq.headers = request.headers.set('UI', UI).set('DeviceInfo', deviceInfo);
      //   transformedReq.body = this.transformService.getEncodedRequest(transformedReq.body);
      // }
      request = request.clone(transformedReq);
    }
    //if (Config.isOffline || url.indexOf('ribbon') !== -1) {
    return next.handle(request).pipe(
      map(postProcessRes),
      catchError(errHandler));
  }

  private getDefaultHeaders() {
    return {
      'Content-Type': 'application/json',
      'Accept': 'text/html, application/xhtml+xml, */*',
    }
  }

  private async handleNativeRequest(request: HttpRequest<any>): Promise<HttpResponse<any>> {
    const headerKeys = request.headers.keys();
    const headers = {};//this.getDefaultHeaders();
    headerKeys.forEach((key) => {
      headers[key] = request.headers.get(key);
    });
    try {
      const method = <HttpMethod>request.method.toLowerCase();
      const reqBody: any = {
        method: method,
        data: request.body,
        headers: headers,
        serializer: 'json'
      };
      if (request.responseType === 'blob') {
        reqBody.responseType = 'blob';
      }
      const nativeHttpResponse = await this.nativeHTTP.sendRequest(request.url, reqBody);
      //const nativeHttpResponse = await this.nativeHTTP.post(request.url, request.body, headers);
      let dataResponse = nativeHttpResponse.data;
      let body;
      //
      const UI = this.commonService.getCurrentPlatformType();
      const transformNWCalls = Config.transformNWCalls && (UI !== 2 ? Config.transformNWCallsDevice : true);
      if (transformNWCalls && dataResponse) {
        try {
          let parsedRes = JSON.parse(dataResponse);
          if (parsedRes && dataResponse.result) {
            dataResponse = this.transformService.transformService(dataResponse.result);
            console.log(dataResponse);
          }
        }
        catch (err) {
          console.error(err);
        }
      }
      try {
        body = JSON.parse(dataResponse);
      } catch (error) {
        if (request.responseType === 'blob') {
          body = dataResponse;
        } else {
          body = { response: dataResponse };
        }
      }
      const response = new HttpResponse({
        body: body,
        status: nativeHttpResponse.status,
        url: nativeHttpResponse.url,
      });
      return Promise.resolve(response);
    } catch (error) {
      if (!error.status) { return Promise.reject(error); }
      const response = new HttpErrorResponse({
        error: JSON.parse(error.error),
        status: error.status,
        headers: error.headers,
        url: error.url,
      });
      return Promise.reject(response);
    }
  }

  
}

